import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Delete } from '@material-ui/icons';
import { useHistory } from 'react-router';
import { Box } from 'UIKit/Grid';
import {
  REQUEST_GET_OLIMPIC_PARTICIPANTS,
  fetchOlimpicParticipants,
  REQUEST_ADD_PARTICIPATION,
  fetchDeleteParticipants,
} from '@/modules/Olimpic';

// import ToolButton from 'sama_global/components/Table/ToolButton';

import OlimpicTable from 'sama_global/components/OlimpicTable';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import { useLoadbar } from 'sama_global/utils/hooks/loadbar';
import Add from 'sama_global/components/StyledButton/Add';
import { cleaRequest } from '@/modules/Requests';

const Participants = ({
  getRating,
  requests,
  user,
  olimpic,
  clearRequest,
  // onDelete,
}) => {
  const id = olimpic?._id;
  useEffect(() => {
    if (id) getRating(id);

    return () => {
      clearRequest(REQUEST_ADD_PARTICIPATION);
    };
  }, [id]);

  const request = requests[REQUEST_GET_OLIMPIC_PARTICIPANTS];

  useSnackbarListener(request?.errorMessage);
  useLoadbar(REQUEST_GET_OLIMPIC_PARTICIPANTS);

  useSnackbarListener(
    requests[REQUEST_ADD_PARTICIPATION]?.success ? 'CREATED' : '',
    'success'
  );
  // useSnackbarListener(
  //   requests[REQUEST_SCHOOL_DELETE]?.success ? 'DELETED' : '',
  //   'success'
  // );
  // useSnackbarListener(requests[REQUEST_SCHOOL_DELETE]?.errorMessage);
  // useLoadbar(REQUEST_SCHOOL_DELETE);
  const [selected, setSelected] = useState([]);

  // const handleDelete = () => {
  //   onDelete(id, { list: selected.map(i => request.data[i]?._id) });
  //   setSelected([]);
  //   getRating(id);
  // };

  const history = useHistory();

  const handleEdit = useCallback(
    (row, { dataIndex }) => {
      history.push({
        pathname: `/olimpic/participants/edit/`,
        state: request.data[dataIndex],
      });
    },
    [request]
  );

  const handleCreate = () => history.push('/olimpic/participants/create');

  return (
    <Box>
      {request?.success && (
        <OlimpicTable
          title="PARTICIPANTS"
          data={request.data}
          options={
            user.role >= 3 && {
              selectToolbarPlacement: 'none',
              rowsSelected: selected,
              selectableRows: user.role > 3 ? 'multiple' : 'none',
              customToolbar: () => (
                <>
                  <Add title="CREATE_PARTICIPANT" onClick={handleCreate} />
                  {/* {user.role > 3 && selected.length > 0 && (
                    <ToolButton
                      title="DELETE_PARTICIPANT"
                      onClick={handleDelete}
                    >
                      <Delete />
                    </ToolButton>
                  )} */}
                </>
              ),
              onRowClick: handleEdit,
              onRowSelectionChange: (c, a, rows) => setSelected(rows),
            }
          }
          result
        />
      )}
    </Box>
  );
};

Participants.propTypes = {
  getRating: PropTypes.func.isRequired,
  clearRequest: PropTypes.func.isRequired,
  // onDelete: PropTypes.func.isRequired,
  requests: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  user: state.user,
  olimpic: state.olimpic.sama,
});

const mapDispatchToProps = dispatch => ({
  getRating(id) {
    dispatch(fetchOlimpicParticipants(id));
  },
  onDelete(id, data) {
    dispatch(fetchDeleteParticipants(id, data));
  },
  clearRequest(name) {
    dispatch(cleaRequest(name));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Participants);
